import axios from 'axios'
import qs from 'qs'

const service = axios.create({
  baseURL: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API), // api 的 base_url
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Accept-Language': 'zh-CN,zh,zh-Hans;q=0.8,en-US;q=0.3,en;q=0.2'
  },
  timeout: 3000000
})
service.interceptors.request.use(

  config => {
    if (config.method === 'get') {
      config.paramsSerializer = function(query) {
        return qs.stringify(query, { arrayFormat: 'repeat' })
      }
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject()
  }
)

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return response.data
    } else {
      Promise.reject()
    }
  },
  error => {
    console.log(error)
    return Promise.reject()
  }
)

export default service
